import {
    Component,
    EventEmitter,
    Inject,
    OnInit,
    Output,
    inject,
    HostListener
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from '../../core/layout/layout.component';
import {AgGridAngular} from 'ag-grid-angular';
import {ColDef} from 'ag-grid-community';
import {Subject, debounceTime, distinctUntilChanged} from 'rxjs';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {HttpClient} from '@angular/common/http';
import {MatOptionModule} from '@angular/material/core';
import {ConfirmDialog} from '../../shared/components/confirm-dialog/confirm-dialog';
// import {PaginationHelper} from '../../shared/services/pagination.service';
import { DepartmentsService } from '../../features/departments/services/departments.service';
import { PermissionService } from '../../shared/services/permission.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
// import * as selectPermissions from '../../core/permissions/permission.selector';
// import { Store } from '@ngrx/store';


@Component({
    selector: 'app-branch',
    standalone: true,
    imports: [
        LayoutComponent, AgGridAngular, MatButtonModule, MatDialogModule, CommonModule
        // PermissionDirective
    ],
    templateUrl: './departments.component.html',
    styleUrls: ['./departments.component.scss']
})
export class DepartmentComponent {
    public viewPortSize : boolean = false;
    public rowData : any[] = [];
    // Permission = Permission;
    canCreateDepartment$ = this.permissionService.hasPermission(
        ModuleIds.Departments,
        'Create'
      );
    canEditDepartment$ = this.permissionService.hasPermission(
        ModuleIds.Departments,
        'Edit'
      );
      canDeleteDepartment$ = this.permissionService.hasPermission(
        ModuleIds.Departments,
        'Delete'
      );
      canDeleteDepartment: boolean = false;
      canEditDepartment: boolean = false;
    
    public columnDefs : ColDef[] = [
        {
            field: 'departmentName',
            headerName: 'Department Name',
            flex: this.viewPortSize ? 1 : 0
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: this.viewPortSize ? 1 : 0,
            cellRenderer: (params : any) => {
                const div = document.createElement('div');
                div.style.display = 'flex';
                div.style.alignItems = 'center';
                div.style.gap = '20px';

                const createButton = (iconSrc : string, onClick : () => void) => {
                    const span = document.createElement('span');
                    span.style.cursor = 'pointer';
                    span.style.display = 'flex';
                    span.innerHTML = `<img src="${iconSrc}"/>`;
                    span.addEventListener('click', onClick);
                    return span;
                };
                // div.appendChild(createButton('assets/images/icons/icon-edit.svg', () => this.openEditDialog(params ?. data)));
                // if(this.profileName === 'admin'){
                // div.appendChild(createButton('assets/images/icons/icon-delete.svg', () => this.onDeleteBranch(params.data ?. id)));
                // }
                // this.store.select(selectPermissions.hasPermission('28', Permission.Edit)).subscribe((canEdit) => {
                //     if (canEdit) {
                        div.appendChild(createButton('assets/images/icons/icon-edit.svg', () => this.openEditDialog(params?.data)));
                //     }
                //   });
                // this.store.select(selectPermissions.hasPermission('28', Permission.Delete)).subscribe((canDelete) => {
                //     if (canDelete) {
                        div.appendChild(createButton('assets/images/icons/icon-delete.svg', () => this.onDeleteBranch(params.data?.id)));
                //     }
                //   });
                return div;
            },
            floatingFilter: false,
            filter: false
        },
    ];
    public defaultColDef : ColDef = {
        filter: 'agTextColumnFilter',
        floatingFilter: true
    };
    public rowSelection : 'single' | 'multiple' = 'multiple';
    public paginationPageSize = 10;
    public paginationPageSizeSelector : number[] | boolean = [10];
    public themeClass : string = 'ag-theme-quartz';
    public loading : boolean = true;
    public error : any = null;

    private searchSubject = new Subject<string>();
    profileName: any;

    constructor(private departmentService : DepartmentsService, private toastr : ToastrService,  private permissionService: PermissionService
        // private store: Store
    ) {
        const loggedInUser: any = localStorage.getItem('loggedInUser');
        const userData = JSON.parse(loggedInUser);
        this.profileName = userData?.profileData?.profileName;
    }

    ngOnInit() {
        this.fetchDepartmentData();

        this.searchSubject.pipe(debounceTime(600), distinctUntilChanged()).subscribe((searchTerm) => {
            this.fetchDepartmentData(searchTerm);
        });
        this.canEditDepartment$.subscribe(val => {
            this.canEditDepartment = val;
          });
          this.canDeleteDepartment$.subscribe(val => {
            this.canDeleteDepartment = val;
          });
        this.checkViewportSize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event : any) {
        this.checkViewportSize();
    }

    checkViewportSize() {
        if (window.innerWidth > 1200) {
            this.viewPortSize = true;
        } else {
            this.viewPortSize = false;
        }
        this.setAGColumn();
    }

    setAGColumn() {
        this.columnDefs = [
            {
                field: 'departmentName',
                headerName: 'Department Name',
                flex: this.viewPortSize ? 1 : 0
            },
            {
                field: 'action',
                headerName: 'Action',
                // flex: this.viewPortSize ? 1 : 0,
                cellRenderer: (params : any) => {
                    const div = document.createElement('div');
                    div.style.display = 'flex';
                    div.style.alignItems = 'center';
                    div.style.gap = '20px';

                    const createButton = (iconSrc : string, onClick : () => void) => {
                        const span = document.createElement('span');
                        span.style.cursor = 'pointer';
                        span.style.display = 'flex';
                        span.innerHTML = `<img src="${iconSrc}"/>`;
                        span.addEventListener('click', onClick);
                        return span;
                    };
                    // div.appendChild(createButton('assets/images/icons/icon-edit.svg', () => this.openEditDialog(params ?. data)));
                    // if(this.profileName === 'admin'){
                    // div.appendChild(createButton('assets/images/icons/icon-delete.svg', () => this.onDeleteBranch(params.data ?. id)));
                    // }
                    // this.store.select(selectPermissions.hasPermission('28', Permission.Edit)).subscribe((canEdit) => {
                        if (this.canEditDepartment) {
                            div.appendChild(createButton('assets/images/icons/icon-edit.svg', () => this.openEditDialog(params?.data)));
                        }
                    //   });
                    // this.store.select(selectPermissions.hasPermission('28', Permission.Delete)).subscribe((canDelete) => {
                        if (this.canDeleteDepartment) {
                            div.appendChild(createButton('assets/images/icons/icon-delete.svg', () => this.onDeleteBranch(params.data?.id)));
                        }
                    //   });
                    return div;
                },
                floatingFilter: false,
                filter: false
            },
        ];
    }

    onDeleteBranch(departmentId : number): void {
        const dialogRef = this.dialog.open(ConfirmDialog);

        dialogRef.afterClosed().subscribe((result) => {
            if (result === true) {
                this.deleteDepartment(departmentId);
            }
        });
    }

    private deleteDepartment(departmentId : number): void {
        this.departmentService.removeDepartmentByid(departmentId).subscribe({
            next: () => {
                this.toastr.success('Department deleted successfully!', 'Success');
                this.fetchDepartmentData();
            },
            error: () => {
                this.toastr.error('Failed to delete department. Please try again.', 'Error');
            }
        });
    }

    private fetchDepartmentData(search : string = '') {
        this.loading = true;
        this.departmentService.fetchDepartments(search).subscribe({
            next: (departments) => {
                let inProgressCount = 0;

                // Sort the departments by 'id' in descending order so the newest branch comes first
                this.rowData = departments.map((department : any) => {
                    const projectsInProgress = Array.isArray(department ?. projects) ? department.projects.filter((project
                    : any) => project.status === 'In-Progress') : [];

                    inProgressCount += projectsInProgress.length;

                    return {
                        id: department ?. id || '--',
                        departmentName: department ?. departmentName || '--',
                    };
                }).sort((a : any, b : any) => b.id - a.id);
                // Sort by ID in descending order

                // Update pagination options based on the rowData length
                // this.paginationPageSizeSelector = PaginationHelper.getPaginationPageSizeOptions(this.rowData);

                this.loading = false;
            },
            error: (error) => {
                this.error = error;
                this.loading = false;
            }
        });
    }

    onSearch(event : Event) {
        const input = event.target as HTMLInputElement;
        const searchTerm = input.value;
        this.searchSubject.next(searchTerm);
    }

    readonly dialog = inject(MatDialog);

    openConfirm() {
        const dialogRef = this.dialog.open(ConfirmDialog);
    }

    openDialog() {
        const dialogRef = this.dialog.open(AddBranchDialog, {disableClose: true});

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'success') {
                this.fetchDepartmentData();
            }
        });
    }

    openEditDialog(departmentId : any) {
        const dialogRef = this.dialog.open(AddBranchDialog, {
            disableClose: true,
            data: departmentId
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'success') {
                this.fetchDepartmentData();
            }
        });
    }
}

const gridDiv = document.querySelector<HTMLElement>('#myGrid')!;

@Component({
    selector: 'add-branch-dialog',
    templateUrl: './add-departments.html',
    styleUrls: ['./departments.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatOptionModule,
        CommonModule,
    ]
})
export class AddBranchDialog implements OnInit {
    @Output()branchAdded = new EventEmitter<any>();
    departmentForm !: FormGroup;
    countries : any[] = [];
    departmentsData : any;
    loading : boolean = false;

    constructor(private departmentService : DepartmentsService, private toastr : ToastrService, private dialogRef : MatDialogRef < AddBranchDialog >, private http : HttpClient, private fb : FormBuilder, @Inject(MAT_DIALOG_DATA)public data : any) {}

    ngOnInit(): void {
        if (this.data) {
            this.departmentsData = this.data;
        }
        this.initForm();
        this.loadCountries();
        // this.generateBranchCode();
    }

    initForm(): void {
        this.departmentForm = this.fb.group({
            id: [this.departmentsData ?. id || ''],
            departmentName: [
                this.departmentsData ?. departmentName || '',
                Validators.required
            ],
        });
    }

    loadCountries(): void {
        this.http.get<any[]>('assets/json/countries.json').subscribe((data) => {
            this.countries = data;
        }, (error) => {
            console.log('Error loading country data----', error);
        });
    }

    onAddBranch(): void {
        if (!this.departmentsData) {
            this.loading = true;
            this.departmentForm.markAllAsTouched();
            if (this.departmentForm.valid) {
                const departmentsData = {
                    ...this.departmentForm.value,
                };
                let {
                    departmentName,
                } = this.departmentForm.value;

                const createBranchInput = {
                    departmentName,
                };
                this.departmentService.createDepartments(createBranchInput).subscribe((response) => {
                    this.loading = false;
                    this.toastr.success('Department added successfully!', 'Success', {
                        timeOut: 5000,
                        progressBar: true,
                        closeButton: true
                    });
                    this.dialogRef.close('success');
                }, (error) => {
                    this.loading = false;
                    let errorMessage = 'Failed to add department. Please try again.';
                    if (error.error && error.error.message) {
                        errorMessage = error.error.message;
                    } else if (error.message === 'Department is not created!') {
                        errorMessage = 'Department already exist with this email!';
                    } else if (error.message) {
                        errorMessage = error.message;
                    }

                    this.toastr.error(errorMessage, 'Error', {
                        timeOut: 5000,
                        progressBar: true,
                        closeButton: true
                    });
                });
            }
        } else {
            this.departmentForm.markAllAsTouched();
            if (this.departmentForm.valid) {
                this.loading = true;
                const departmentsData = {
                    ...this.departmentForm.value,
                };
                this.departmentService.updateDepartment(departmentsData).subscribe((response) => {
                    this.loading = false;
                    this.toastr.success('Department updated successfully!', 'Success', {
                        timeOut: 5000,
                        progressBar: true,
                        closeButton: true
                    });
                    this.dialogRef.close('success');
                }, (error) => {
                    this.loading = false;
                    let errorMessage = 'Failed to update department. Please try again.';
                    if (error.error && error.error.message) {
                        errorMessage = error.error.message;
                    } else if (error.message) {
                        errorMessage = error.message;
                    }

                    this.toastr.error('Failed to update department. Please try again.', 'Error', {
                        timeOut: 5000,
                        progressBar: true,
                        closeButton: true
                    });
                });
            }
        }
    }
}
